import React, { FC, useState }             from "react";
import { useDropzone }                     from "react-dropzone";
import { useDispatch }                     from "react-redux";
import { Button, Card, Form, Icon, Modal } from "semantic-ui-react";
import CustomerRecordRepository            from "../../../../../domain/record/customer/CustomerRecordRepository";
import CustomerRecordWidget                from "../../../../../domain/record/customer/widget/CustomerRecordWidget";
import WidgetValue                         from "../../../../../domain/record/widget/WidgetValue";
import CustomerRecordDataSource
                                           from "../../../../../infrastructure/datasource/record/customer/CustomerRecordDataSource";
import ImageDropZoneBody                   from "./layout/ImageDropZoneBody";
import ImageLargePreview                   from "./layout/ImageLargePreview";
import ImageLargeRoot                      from "./layout/ImageLargeRoot";

interface Props {
  widgetIndex: number;
  widget: CustomerRecordWidget;
}

const ImageLargeWidget: FC<Props> = (props: Props) => {
  const {getRootProps, getInputProps, open} = useDropzone({
    accept: "image/gif, image/jpeg, image/png, image/jpg",
    noClick: true,
    maxSize: 10485760,
    onDrop: acceptedFiles => {
      const file: File = acceptedFiles[0];
      const fileReader: FileReader = new FileReader();
      fileReader.readAsDataURL(file);
      fileReader.onload = (event) => {
        if (event.target !== null) {
          repository.setCustomerRecordWidget(widgetIndex, new CustomerRecordWidget(widget.id, widget.widgetId, widget.type, widget.coordinate, widget.title, new WidgetValue(String(event.target.result)), widget.items))
        }
      };
    }
  });
  const [isDeleteDialog, openDeleteDialog] = useState(false);
  const {widgetIndex, widget} = props;
  const repository: CustomerRecordRepository = new CustomerRecordDataSource(useDispatch());
  return (
    <>
      <div
        style={ {
          position: "absolute",
          left: `${ widget.coordinate.x }px`,
          top: `${ widget.coordinate.y }px`
        } }
        key={ widgetIndex }
      >
        <Card style={ {width: "460px"} }>
          <Card.Content>
            <Form>
              <Form.Field>
                <label>{ widget.title.value }</label>
                {
                  widget.value.isEmpty() ?
                    <>
                      <ImageLargeRoot { ...getRootProps() }>
                        <input { ...getInputProps() }/>
                        <ImageDropZoneBody>
                          ここに画像をドロップ<br/>または<br/>
                          <Button onClick={ open } size="tiny">
                            画像を選択
                          </Button>
                          <br/>
                          <small>対応形式: jpg/jpeg/png/gif</small>
                        </ImageDropZoneBody>
                      </ImageLargeRoot>
                    </>
                    :
                    <>
                      <ImageLargePreview
                        src={ widget.value.value }
                        onClick={ () => openDeleteDialog(true) }
                      />
                    </>
                }
              </Form.Field>
            </Form>
          </Card.Content>
        </Card>
      </div>

      <Modal
        open={ isDeleteDialog }
      >
        <Modal.Header>画像の削除</Modal.Header>

        <Modal.Content>
          <p>現在の画像を削除します。よろしいですか？</p>
        </Modal.Content>

        <Modal.Actions>
          <Button onClick={ () => openDeleteDialog(false) }>閉じる</Button>
          <Button
            icon
            labelPosition="left"
            negative
            onClick={ () => {
              repository.setCustomerRecordWidget(widgetIndex, new CustomerRecordWidget(widget.id, widget.widgetId, widget.type, widget.coordinate, widget.title, new WidgetValue(), widget.items));
              openDeleteDialog(false);
            } }
          >
            <Icon name="trash"/>
            削除する
          </Button>
        </Modal.Actions>
      </Modal>
    </>
  );
};

export default ImageLargeWidget;
